<div>
    <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
        <label *ngIf="locationSet.disabled === true">Status:</label>
        <td *ngIf="locationSet.disabled === true">
            <mat-form-field>
                <mat-select
                    [disabled]="true"
                    [value]="locationSet.disabled"
                >
                    <mat-option [value]="true">Disabled</mat-option>
                </mat-select>
            </mat-form-field>
        </td>
    </div>
    <div    class="flex-gap-10vw flex-space-between-center flex-row">
        <label>Effective Date:</label>
        <mat-form-field>
            <input
                [matDatepicker]="picker"
                matInput
                [(ngModel)]="selectedDate"
                (ngModelChange)="handleDateChange()"
                [disabled]="!canEdit"
            />
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
        <label>Profile:</label>
        <mat-form-field>
            <mat-select
                [(ngModel)]="profile"
                (ngModelChange)="changeFormReadyTo(true)"
                [disabled]="!canEdit"
            >
                <mat-option [value]="'Not Set'">Not Set</mat-option>
                <mat-option
                    *ngFor="let option of profileOptions$ | async"
                    [value]="option"
                >
                    {{ option }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="mat-elevation-z8 table-container" *ngIf="showHierarchyTableToggle$ | async">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="effectiveDate"
           matSortDirection="desc" matSortDisableClear aria-describedby="unpublished changes">

        <ng-container matColumnDef="nutritionProfile">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="nutritionProfile">Nutrition Profile</th>
            <td mat-cell *matCellDef="let row">{{ row.nutritionProfile || "Not Set" }}</td>
        </ng-container>

        <ng-container matColumnDef="locationLevel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="locationName">Location Level</th>
            <td mat-cell *matCellDef="let row">{{ row.locationName }}</td>
        </ng-container>

        <ng-container matColumnDef="effectiveDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="effectiveDate">Effective Date</th>
            <td mat-cell *matCellDef="let row">{{ row.effectiveDate | date:'shortDate' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data found</td>
        </tr>
    </table>
</div>
